// extracted by mini-css-extract-plugin
export default {"talentLink":"LinkWrapper_talentLink__wYKj0"};